<template>
  <div class="bankNumber formWrapper">
    <div class="formWrapper__header">
      <Icon icon="bank-account-number" class="formWrapper__header__icon" />
      <h3 class="bankNumber__header">Numer rachunku</h3>
    </div>
    <div class="formWrapper__inner">
      <p>
        Podaj numer rachunku, z którego dokonasz płatności za zamówienie.
        Podany poniżej rachunek musi być prowadzony na rzecz zamawiającego.
        Wszystkich płatności z tytułu zamówienia należy dokonywać <span class="text-danger">wyłącznie</span> z tego rachunku.

      </p>
      <section class="bankNumber__form">
        <basic-masked-input
          validationRule="accountNumber|required"
          inputType="text"
          v-model="accountNumber"
          placeholder="Numer rachunku bankowego"
          :mask="'##-####-####-####-####-####-####'"
          label="Numer rachunku bankowego"
          name="bankAccountNumber"
        />
      </section>
      <bank-number-confirmation v-if="showVatExceptionCheckbox" />
    </div>
  </div>
</template>

<script>

import { mapFields } from 'vuex-map-fields';
import BasicMaskedInput from '../Inputs/basicMaskedInput.vue';
import BankNumberConfirmation from './BankNumberConfirmation.vue';
import Icon from '../Icon.vue';

export default {
  name: 'bankNumberFromWrapper',
  components: { BasicMaskedInput, Icon, BankNumberConfirmation },
  computed: {
    ...mapFields('bankNumber', ['accountNumber', 'showVatExceptionCheckbox']),
  },
};
</script>
<!-- using /deep/ can target child componet and style them   -->
<style scoped>
  .bankNumberForm {
    margin: 0 15px 30px 15px;
  }
  /deep/ label {
    min-width: 220px;
  }
</style>
